import { deburr } from 'lodash'
import moment from 'moment'
import reactStringReplace from 'react-string-replace'

export * from './Analytics'
export { default as storage } from './Storage'

const CURRENT_MONTH = new Date().getMonth()

export const isOctober = () => CURRENT_MONTH === 9
export const isDecember = () => CURRENT_MONTH === 11

export const ageToHuman = (time: number, unitDeep: number = 0) => {
  const utcTime = moment.utc(time)
  const units: string[] = []

  const years = moment().utc().diff(moment(utcTime), 'years')
  if (years) {
    units.push(`${years} año${years === 1 ? '' : 's'}`)
    utcTime.add(years, 'years')
  }

  if (units.length < unitDeep) {
    const months = moment().utc().diff(moment(utcTime), 'months')
    if (months) {
      units.push(`${months} mes${months === 1 ? '' : 'es'}`)
      utcTime.add(months, 'months')
    }

    if (units.length < unitDeep) {
      const weeks = moment().utc().diff(moment(utcTime), 'weeks')
      if (weeks) {
        units.push(`${weeks} semana${weeks === 1 ? '' : 's'}`)
        utcTime.add(weeks, 'weeks')
      }

      if (units.length < unitDeep) {
        const days = moment().utc().diff(moment(utcTime), 'days')
        units.push(`${days} día${days === 1 ? '' : 's'}`)
      }
    }
  }

  return units.join(', ')
}

export const ageInYears = (time?: number) =>
  moment()
    .utc()
    .diff(moment.utc(time || 0), 'years')

export const highlightString = (str: string = '', strToHighlight: string = '') =>
  reactStringReplace(
    str,
    new RegExp(`(${strToHighlight.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, String.raw`\$&`)})`, 'mig'),
    (match, index) => (
      <span key={index} className="text-greyDarkBlue px-[0.075em] border-y-2 border-primary rounded">
        {match}
      </span>
    ),
  )

export const isGlobalAdmin = (user: { email?: string; username?: string; usuario?: string } = {}) =>
  !!(user.email || user.username || user.usuario || '').match(/@(sweatbits)\.co$/i)

export const setDocumentTitle = (...texts: (boolean | number | string | undefined)[]) => {
  const cleanTexts = texts.map((text) => text && deburr(String(text).trim())).filter(Boolean)
  if (cleanTexts.length >= 3) {
    document.title = cleanTexts.join(' ').replace(/([^a-z0-9]+)/gi, '-')
    return true
  }
  return false
}

let sentryMetrics: unknown
let sentryTags: Record<string, boolean | number | string> | undefined
const SENTRY_METRICS_DEBUG = process.env.NODE_ENV === 'development'

export const setSentryMetrics = (metrics: unknown) => {
  sentryMetrics = metrics
}
export const setMetricTag = (name: string, value: boolean | number | string) => {
  sentryTags = {
    ...sentryTags,
    [name]: value,
  }
}

export const addMetric = (name: string, value: number = 1) => {
  // @ts-expect-error sentryMetric not defined
  sentryMetrics?.increment(name, value, { tags: sentryTags })
  if (SENTRY_METRICS_DEBUG) {
    // eslint-disable-next-line no-console
    console.groupCollapsed('Metric.increment', name, '>', value)
    // eslint-disable-next-line no-console
    console.table(sentryTags)
    // eslint-disable-next-line no-console
    console.groupEnd()
  }
}

export const setMetric = (name: string, value: number | string) => {
  // @ts-expect-error set not defined
  sentryMetrics?.set(name, value, { tags: sentryTags })
  if (SENTRY_METRICS_DEBUG) {
    // eslint-disable-next-line no-console
    console.groupCollapsed('Metric.set', name, '>', value)
    // eslint-disable-next-line no-console
    console.table(sentryTags)
    // eslint-disable-next-line no-console
    console.groupEnd()
  }
}
